import { render, staticRenderFns } from "./DeductiblesQuotator.vue?vue&type=template&id=f82b5fd4&scoped=true&"
import script from "./DeductiblesQuotator.vue?vue&type=script&lang=js&"
export * from "./DeductiblesQuotator.vue?vue&type=script&lang=js&"
import style0 from "./DeductiblesQuotator.vue?vue&type=style&index=0&id=f82b5fd4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82b5fd4",
  null
  
)

export default component.exports